import {
    type CreateCompanyForAdminResponseType,
    type CreateCompanyForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const CreateCompanyForAdmin = async (params: CreateCompanyForAdminRequestType): Promise<CreateCompanyForAdminResponseType> => {
    return await request<CreateCompanyForAdminResponseType>("/company/createCompanyForAdmin", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateCompanyForAdmin;
